const animateValue = (obj, start, end, duration) => {
    let startTimestamp = null;
    const step = (timestamp) => {
        if (!startTimestamp) {
            startTimestamp = timestamp;
        }
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        obj.innerHTML =
            Math.floor(progress * (end - start) + start)
                .toLocaleString('sv-SE');
        if (progress < 1) {
            window.requestAnimationFrame(step);
        }
    };
    window.requestAnimationFrame(step);
};

const observeUSPValues = () => {
    const elements = document.querySelectorAll('.usp');
    if (!elements.length) {
        return;
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const target = parseInt(entry.target.innerHTML.replace(
                    /\s/g,
                    '',
                ), 10);
                if (!isNaN(target)) {
                    entry.target.innerHTML = '0';
                    animateValue(entry.target, 0, target, 2000);
                }
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.1,
    });

    elements.forEach(element => observer.observe(element));
};

document.addEventListener('DOMContentLoaded', observeUSPValues);
//# sourceMappingURL=usp.js.map
